// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isAppsAppGroupIdChartsWebhookResult = objectOf({
  daily_webhook_stats: objectOf({
    sent_count_by_hour: arrayOf(arrayOf(number)),
    error_count_by_hour: arrayOf(arrayOf(number)),
  }),
});
